import { Routes } from '@angular/router';
import { EditProtectionGreleComponent } from './edit-protection-grele/edit-protection-grele.component';
import { ListesProtectionsGreleComponent } from './listes-protections-grele/listes-protections-grele.component';

export const PROTECTIONS_GRELE_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const PROTECTIONS_GRELE_ROUTES: Routes = [
    { path: '', component: ListesProtectionsGreleComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditProtectionGreleComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditProtectionGreleComponent, data: { roles: ['ORGANISME'] } }
];
